module.exports = __webpack_public_path__ + "static/img/user2_1.efcab915.png";